import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	whatYouGetTitle: {
		id: 'trial.thomas.whatYouGetTitle',
		defaultMessage: 'What do you get with Calm?',
		description: "Header for introducing Calm's features",
	},
	item1Heading: {
		id: 'trial.whatYouGet.heading1',
		defaultMessage: 'Sleep Stories',
		description: 'Feature name: Sleep Stories',
	},
	item1Description: {
		id: 'trial.whatYouGet.description1',
		defaultMessage:
			'150+ Sleep Stories, with new ones added each week to lull you into a deep and restful slumber.',
		description: 'Feature description for Sleep Stories',
	},
	item2Heading: {
		id: 'trial.whatYouGet.heading2',
		defaultMessage: 'Guided Meditations',
		description: 'Feature name: Guided Meditations',
	},
	item2Description: {
		id: 'trial.whatYouGet.description2',
		defaultMessage: 'Hundreds of hours of meditations to help you relax your mind and body.',
		description: 'Feature description for Guided Meditations',
	},
	item3Heading: {
		id: 'trial.whatYouGet.heading3',
		defaultMessage: 'Calm Music',
		description: 'Feature name: Calm Music',
	},
	item3Description: {
		id: 'trial.whatYouGet.description3',
		defaultMessage:
			'Exclusive music from artists like Sam Smith, Moby, Above & Beyond, Sigur Ros, to help you focus, relax and sleep.',
		description: 'Feature description for Calm Music',
	},
	item4Heading: {
		id: 'trial.whatYouGet.heading4',
		defaultMessage: 'And more...',
		description: 'There are more features!',
	},
	item4Description: {
		id: 'trial.whatYouGet.description4',
		defaultMessage: 'Soothing nature sounds and scenes, breathing programs, stretching exercises and more.',
		description: 'List some more features that we have not yet already highlighted',
	},
});
